module.exports = __webpack_public_path__ + "static/media/library_active.e291c719.svg";